<template>
	<div>
		<v-tabs
			class="round-card"
			height="34"
			background-color="background-1"
			slider-color="primary">
			<v-tab key="Altro" ripple class="secondary-tab">
				Altro
			</v-tab>

			<v-tab-item class="background-1 pt-3 pb-1 pb-offset" key="Altro">
				<v-row class="ma-0">
					<v-col cols="12" class="pa-1">
						<v-card elevation="1" class="background-2 round-card">
							<v-card-title class="pa-3">
								<p class="pl-2 pl-xl-3">Impostazioni Lista di Prelievo</p>
							</v-card-title>
							<v-divider></v-divider>
							<v-container class="pa-0 pt-4" fluid>
								<v-row class="pa-4">
									<v-col class="pt-0 pb-0 px-4" cols="12">
										<v-switch
											label="Abilita la selezione di tutti i fornitori disponibili"
											v-model="settings['allow_all_suppliers']"
											color="primary"
											dense
											inset
											hide-details
											class="margin-auto"
										></v-switch>
										<p class="caption grey--text mt-2 ml-12">
											Se attivo, nella lista di prelievo sarà possibile selezionare qualsiasi fornitore disponibile.
											Se disattivo, sarà possibile selezionare solo i fornitori associati al prodotto.
										</p>
									</v-col>
								</v-row>
							</v-container>
							<v-divider></v-divider>
							<v-card-actions class="pr-4">
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

	export default {
		name: 'picklist-settings',
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'picklist',
				settings: {
					'allow_all_suppliers': false
				}
			}
		},
	}
</script>
